import { AppBar, SxProps } from "@mui/material";
import { FC } from "react";

import DARSLogo from "./DARSLogo";

const style: SxProps = {
  padding: 2,
  paddingBottom: "2rem",
  m: 0,
  bgcolor: "#ffffff",
};

const PPFooter: FC<{}> = () => {
  return (
    <AppBar elevation={0} position="static" sx={{ ...style }}>
      <DARSLogo />
    </AppBar>
  );
};

export default PPFooter;
//PPFooter.whyDidYouRender = true;
